import type { ComponentType } from "react";

// Lazy MDX body loader for /blog/@slug (RESEARCH Pattern 1, spike-verified).
//
// Each post body is its own chunk (lazy glob, never eager here: an eager glob would merge every
// post into one bundle, Pitfall 5). vike-react's onBeforeRenderHtml (server) and
// onBeforeRenderClient (client) both call preloadPost, so the component is already resolved when
// React renders: the SSR HTML carries the full article. A lazy component behind a suspense
// boundary is NOT used on purpose: under renderToString it ships the fallback instead of the body.
//
// `loaders` is bounded module state: a fixed set of N post files known at build time.

type MdxContent = ComponentType<{ components?: Record<string, ComponentType<any>> }>;
type MdxModule = { default: MdxContent };

const bodies = import.meta.glob<MdxModule>("/src/content/blog/*.mdx");

const loaders = new Map<string, () => Promise<MdxModule>>(
  Object.entries(bodies).map(([path, load]) => [
    path.slice(path.lastIndexOf("/") + 1).replace(/\.mdx$/, ""),
    load,
  ]),
);

export async function preloadPost(pageContext: {
  routeParams?: Record<string, string>;
  blogPostContent?: MdxContent | null;
}): Promise<void> {
  const load = loaders.get(pageContext.routeParams?.slug ?? "");
  pageContext.blogPostContent = load ? (await load()).default : null;
}
